import { render, staticRenderFns } from "./tastes.vue?vue&type=template&id=00fddd22&scoped=true&"
import script from "./tastes.vue?vue&type=script&lang=js&"
export * from "./tastes.vue?vue&type=script&lang=js&"
import style0 from "./tastes.vue?vue&type=style&index=0&id=00fddd22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fddd22",
  null
  
)

export default component.exports